import type { ForwardedRef } from 'react';

import { Card, Image, Link, Text } from '@change/ds-core-ui';

import { forwardRef } from '@change-corgi/core/react/core';

import type { NewsAndGuidesListItem } from 'src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from 'src/app/pages/newsAndGuides/list/shared/hooks';

type Props = {
	item: NewsAndGuidesListItem;
};

export function BasicCardInner({ item }: Props, ref: ForwardedRef<HTMLAnchorElement>) {
	const {
		data: { categoryName, targetUrl, smallPhotoUrl },
	} = useItemCard(item);

	return (
		<Card
			as={Link}
			href={targetUrl}
			className="relative overflow-hidden no-underline [&_*]:no-underline"
			elevation
			ref={ref}
		>
			{smallPhotoUrl && (
				<Image
					src={smallPhotoUrl}
					alt=""
					className="absolute inset-0 h-full w-full object-cover opacity-10"
					loading="lazy"
					role="presentation"
				/>
			)}
			<div className="relative z-10 px-4 py-10">
				<Text as="span" fontWeight="bold" size="x-small" className="uppercase text-typography-weak">
					{categoryName}
				</Text>
				<Text as="h2" variant="heading" size="x-small" className="mb-6 mt-2 text-typography-strong">
					{item.title}
				</Text>
				<Text as="span" size="x-small" className="text-typography-weak">
					{item.createdAtLocalized}
				</Text>
			</div>
		</Card>
	);
}

export const BasicCard = forwardRef(BasicCardInner);
